import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './Login.css';
import Logo from './Logo';
import { useTracking } from '../hooks/useTracking';
import { buildApiUrl } from '../utils/api';

const Login = ({ onLogin, onVerificationRequired }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { trackLogin } = useTracking();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(buildApiUrl('/api/login'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        // Armazenar informações completas do usuário incluindo role e permissões
        const userData = {
          ...data.user,
          role: data.role || data.user?.role || 'user'
        };
        
        // Salvar token ANTES de trackLogin (precisa do token para enviar)
        localStorage.setItem('token', data.token);
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // Registrar login no sistema de analytics
        await trackLogin();
        
        // Fazer login na aplicação
        onLogin(data.token, userData);
      } else {
        if (data.requiresVerification) {
          onVerificationRequired(data.userId);
        } else {
          setError(data.message || 'Erro ao fazer login');
        }
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="auth-pattern"></div>
      </div>
      
      <div className="auth-card">
        <div className="auth-header">
          <div className="company-logo">
            <Logo size="xlarge" className="auth-title" />
          </div>
          <p className="auth-subtitle">Acesse sua conta para fazer pedidos</p>
        </div>
        
        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">Nome de usuário</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Digite seu nome de usuário"
              className="form-input"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Digite sua senha"
              className="form-input"
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spin 
                  indicator={<LoadingOutlined style={{ fontSize: 20, color: '#fff' }} spin />} 
                  style={{ marginRight: 8 }}
                />
                Entrando...
              </>
            ) : (
              'Entrar no Sistema'
            )}
          </button>
        </form>

        <div className="auth-links">
          <p className="auth-link">
            <Link to="/microsoft-login" className="link-secondary">Login com Microsoft</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 